export default __webpack_public_path__ + "static/centered-results-4-515d7e5599447ba9f38e4720a630bc1e.png";